import * as React from 'react';

import DocGenIcon from './DocGenIcon';

export const docGenIcon = () => <DocGenIcon />;

export default {
    title: 'Icon/Fill/DocGenIcon',
    component: DocGenIcon,
    parameters: {
        notes: "`import DocGenIcon from 'box-ui-elements/es/icon/fill/DocGenIcon';`",
    },
};
